import React, { useState } from "react";
import * as s from "./index.module.scss";
import { Col, Container, Row } from "react-bootstrap";
import { IoArrowForward } from "react-icons/io5";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";
import Popups from "../../Common/Popups";
import Link from "next/link";

const SellYourWatches = ({ data, page }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className={`section-center ${s.sell_your_watches}`}>
      <Container>
        <Row className="align-items-center">
          <Col md={6} xxl={7}>
            <Row>
              {data?.watches.map((item, idx) => {
                if ((idx + 1) % 2 === 0)
                  return (
                    <Col className="mb-4" xs={5} key={idx}>
                      <img
                        loading="lazy"
                        src={item?.watche.url}
                        alt={item.watche.alt || "image"}
                      />
                    </Col>
                  );
                return (
                  <Col className="mb-4" xs={7} key={idx}>
                    <img
                      loading="lazy"
                      src={item?.watche.url}
                      alt={item?.watche.alt || "image"}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
          <Col md={6} xxl={5}>
            <h3 className="fw-bold">{data.title}</h3>
            <div className={`${secondaryFont} paragraph`}>
              <PrismicRichText field={data?.desc || []} />
            </div>
            <div className={s.button_container}>
              <button
                className={`btn btn-primary ${secondaryFont}`}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                {data.buttonText}
                <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
              </button>
              <Link
                className={`btn btn-outline-dark view-btn ${secondaryFont}`}
                href={data.viewLink}
              >
                View More
                <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
              </Link>
            </div>
          </Col>
        </Row>
        <Popups
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          page={page}
        />
      </Container>
    </section>
  );
};

export default SellYourWatches;
